import Favicon from "@/public/Favicon.svg";
import { Image } from '@/lib/target';
const NoData = ({message = 'Đang cập nhật ...'}) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Image src={Favicon} className="w-[9rem] h-[7.375rem] my-4" />
      <p className="text-dark-gray dark:text-stroke-o3 text-[0.75rem] text-center p-4">{message}</p>
    </div>
  );
}
export default NoData;